import {assign} from 'lodash';
import {ApiClientCommunication} from 'neo-common';
import {LaunchClientResponse} from './LaunchClientResponse';

export class LaunchClientRequest extends ApiClientCommunication.RequestBase<LaunchClientResponse> {
    constructor(params: Object) {
        super();
        assign(this, params);
    }

    createResponse(responseJson: ApiClientCommunication.Types.RawResponseType): LaunchClientResponse {
        return new LaunchClientResponse(responseJson);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Communication/Launch/LaunchClientRequest.ts
 **/